export enum ActionType {
  // creatte user
  SEND_FULL_NOTIFICATION = "action/SEND_FULL_NOTIFICATION",
  SEND_FULL_NOTIFICATION_SUCCESS = "action/SEND_FULL_NOTIFICATION_SUCCESS",
  SEND_FULL_NOTIFICATION_ERROR = "action/SEND_FULL_NOTIFICATION_ERROR",
  RESET_SEND_FULL_NOTIFICATION = "action/RESET_SEND_FULL_NOTIFICATION",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface SendFullStressNotificationData {
  user_ids?: string;
  short_text: string;
  notification_text: string;
}
